import { render, staticRenderFns } from "./payrollitemcontent.vue?vue&type=template&id=739bdf84"
import script from "./payrollitemcontent.vue?vue&type=script&lang=js"
export * from "./payrollitemcontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports